/**
 * Checks for invalid characters within the provided query string.
 *
 * @param {string} queryString The query string.
 *
 * @example
 * ```js
 * const isValid = isValidQueryString( 'query=true&another=false' ); // true
 * const isNotValid = isValidQueryString( 'query=true?another=false' ); // false
 * ```
 *
 * @return {boolean} True if the argument contains a valid query string.
 */
export function isValidQueryString( queryString ) {
	if ( ! queryString ) {
		return false;
	}
	return /^[^\s#?\/]+$/.test( queryString );
}
